var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckOrangeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 92,
    viewBox: "0 0 93 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.0375 86C24.9694 86 7 68.0556 7 45.9875C7 23.9444 24.9694 6 47.0375 6C69.0806 6 87.025 23.9944 87 46.0625C86.975 68.0556 69.0306 85.975 47.0375 86ZM40.8144 52.6354C39.4149 51.3608 38.1653 50.2112 36.8906 49.0615C34.5164 46.9122 32.2171 44.6629 29.7429 42.6136C27.5436 40.7891 24.4445 41.8138 23.6448 44.513C23.12 46.3124 23.7947 47.7619 25.1443 48.9616C29.343 52.7604 33.5167 56.5842 37.7154 60.383C40.2146 62.6573 42.039 62.5823 44.4133 60.2331C48.9119 55.7844 53.4105 51.3108 57.8841 46.8622C61.6079 43.1634 65.3318 39.4645 69.0556 35.7907C70.3052 34.5661 70.93 33.1415 70.3302 31.3921C69.2555 28.318 65.8316 27.6182 63.4074 30.0175C59.8335 33.5664 56.2846 37.1403 52.7107 40.6892C48.7619 44.6379 44.8382 48.5867 40.8144 52.6354Z",
    fill: "#FC6631"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckOrangeImage);
export default __webpack_public_path__ + "static/media/check-orange-image.ab6aacbbe66875cd780d01ecd573c70a.svg";
export { ForwardRef as ReactComponent };